import { getImageUrl } from '../../helper/constants';
export default function ProductCard({ img, name, open, distance }) {

    return (
        <div className="product_card_wrapper">
            <div className="product_card">
                <div className="product_card_image">
                    <img src={getImageUrl(img)} />
                </div>
                <div className="product_card_text">
                    <div className="product_card_name" title={name}>{name}</div>
                    <div className="product_card_open">{open} </div>
                    <div className="product_card_dist">{distance} </div>
                </div>
            </div>
        </div>
    );
}